export default "__VITE_ASSET__ccaa6f65__"